import React, { FC, useEffect, useState } from 'react';
import { ApprovalPageComponentProps } from './ApprovalPageComponentProps';
import { Stack } from '@mui/material';
import ApprovalHeader from '../ApprovalHeader';
import ApprovalTable from '../ApprovalTable';
import { gridFilteredSortedRowIdsSelector } from '@mui/x-data-grid-premium';
import {
  emptySettings,
  useDatagridSettings,
} from '../../hooks/useDatagridSettings';
import { calculateStats, returnStatistics } from '../ProjectListTable/utils';
import { EUR } from '../../constants';
import {
  DEFAULT_VIEW_COLUMNS,
  returnApprovalTableColumns,
} from '../ApprovalTable/utils';
import useTranslation from '../../hooks/useTranslation';

const ApprovalPageComponent: FC<ApprovalPageComponentProps> = ({
  onSelectedCRPValuesChange,
  selectedCRPValues,
  projects,
  countriesOptions,
  selectedCountry,
  onSelectedCountryChange,
  setTableSelection,
  tableSelection,
  approveProject,
  onRowClick,
  captureRevisedBudget,
  archiveProject,
  loading,
  directiveClickedEvent,
}) => {
  const t = useTranslation();
  const columns = returnApprovalTableColumns(t, [], directiveClickedEvent);
  const settings = useDatagridSettings('approveList', null, {
    ...emptySettings,
    columnsVisibility: columns.reduce(
      (acc, col) => ({
        ...acc,
        [col.field]: DEFAULT_VIEW_COLUMNS.includes(col.field),
      }),
      {},
    ),
  });
  const gridApi = settings?.datagridProps?.apiRef;
  const [stats, setStats] = useState([]);
  const [filtersSet, setFiltersSet] = useState(false);

  useEffect(() => {
    if (filtersSet || selectedCountry.length === 0) return;
    if (!gridApi?.current?.upsertFilterItem) return;
    setFiltersSet(true);
    gridApi.current.upsertFilterItem({
      id: 'countryCode-isAnyOf',
      field: 'countryCode',
      operator: 'isAnyOf',
      value: selectedCountry,
    });
    return () => {
      setFiltersSet(false);
    };
  }, [selectedCountry]);

  useEffect(() => {
    const ids = gridFilteredSortedRowIdsSelector(gridApi);
    const filteredProjects = ids
      .map((id) => projects.find((p) => p.id === id))
      .filter(Boolean);

    const stats = calculateStats(
      filteredProjects,
      selectedCountry.length === 1
        ? filteredProjects[0]?.currencySymbol || ''
        : '',
    );
    setStats(
      returnStatistics(
        stats,
        selectedCountry.length === 1 &&
          filteredProjects[0] &&
          filteredProjects[0]?.currencySymbol !== EUR,
        filteredProjects.length,
      ),
    );
  }, [
    settings.datagridProps.filterModel,
    selectedCountry,
    selectedCRPValues,
    projects,
  ]);
  return (
    <Stack spacing={4} height={'100%'}>
      <ApprovalHeader
        onSelectedCRPValuesChange={onSelectedCRPValuesChange}
        selectedCRPValues={selectedCRPValues}
        stats={stats}
        loading={loading}
      />
      <ApprovalTable
        projects={projects}
        countryOptions={countriesOptions}
        selectedCountries={selectedCountry}
        onSelectedCountriesChange={onSelectedCountryChange}
        tableSettings={settings}
        setTableSelection={setTableSelection}
        tableSelection={tableSelection}
        approveProject={approveProject}
        columns={columns}
        onRowClick={onRowClick}
        captureRevisedBudget={captureRevisedBudget}
        archiveHandler={archiveProject}
        loading={loading}
      />
    </Stack>
  );
};

export default ApprovalPageComponent;
